
















import { Vue, Component, Model } from 'vue-property-decorator'
import { APP_UPDATED } from '@/constants/messages'

@Component
export default class ModalNewVersion extends Vue {
	showModal = false

	created() {
		window.addEventListener('message', this.onMessageListener)
	}

	onMessageListener({ data }: { data: string }) {
		if (data === APP_UPDATED) {
			this.showModal = true
		}
	}

	update() {
		document.location.reload()
	}
}
